import React from "react";
import "./Tabbutton.css";

const Tabbutton = (props) => {
  return (
    <button
      type="button"
      className="tablinks"
      onClick={() => !props.disabled && props.handleClick(props.tabId)}
      style={{
        backgroundColor:
          props.tabSelected === props.tabId
            ? "var(--inputBackgroundColorDisabled)"
            : "var(--inputBackgroundColor)",
        color: "var(--textColor)",
        borderBottom:
          props.tabSelected === props.tabId
            ? "2px solid var(--textColor)"
            : "none",
        fontWeight: props.tabSelected === props.tabId ? "bold" : "normal",
      }}
    >
      {props.tabButtonLabel}
    </button>
  );
};

export default Tabbutton;
